<template>
  <div class="dashboard-kpis">
    <div class="kpi-row">
      <div v-for="(kpi, key) in kpiData"
           :class="['kpi-wrapper', kpi.class]"
           :key="key">
        <kpi-block
            :apiParams="apiParams"
            :currency="kpi.currency"
            :kpiKey="key"
            :percentage="kpi.percentage"
            :iconId="kpi.iconId"
            :iconViewbox="kpi.viewBox"
            :title="kpi.title"
            :url="`/dashboard/${key}`"
            wrapperClasses="dashboard-kpis"
            usesLift
            @setLiftData="setLiftData">
        </kpi-block>
        <div class="divider"></div>
        <div :class="['lift', { negative: kpi.negative }]"> {{ kpi.liftData }} </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { NumberFormatters } from '../mixins/NumberFormatters.js'
  import KpiBlock from '../KpiData/KpiBlock.vue'
  import Tooltip from '../Shared/Tooltip'

  export default {
    props: {
      advertiserId: [Number, String],
      dateRange: Object,
      prevRangeLabel: String,
    },

    name: 'DashboardKpis',

    mixins: [NumberFormatters],

    components: {
      KpiBlock,
      Tooltip
    },

    data() {
      return {
        kpiData: {},
      }
    },

    methods: {
      configureKpis() {
        let merchantKpis = {
          messages_sent: {
            title: 'messages sent',
            iconId: 'paper-plane-icon',
            viewBox: '512 512',
            liftData: null,
            negative: false,
          },
          retailers_sent: {
            title: 'retailers sent',
            iconId: 'pointer-icon',
            viewBox: '300 300',
            liftData: null,
            negative: false,
          },
          purchases: {
            title: 'purchases',
            iconId: 'cart-icon',
            viewBox: '440 440',
            liftData: null,
            negative: false,
          },
          total_units: {
            title: 'total units',
            iconId: 'shopping-bag-icon',
            viewBox: '212 212',
            liftData: null,
            negative: false,
          },
          revenue_generated: {
            title: 'revenue generated',
            iconId: 'dollar-icon',
            viewBox: '340 340',
            liftData: null,
            negative: false,
          }
        }
        this.kpiData = merchantKpis
      },

      setLiftData(liftData, kpiKey) {
        const isNegative = liftData < 0,
          kpi = this.kpiData[kpiKey]
        kpi['liftData'] = liftData ? `${liftData}%/${this.prevRangeLabel}` : '--'
        kpi['negative'] = liftData ? isNegative : false
      },
    },

    created() {
      this.configureKpis()
    },

    computed: {
      apiParams: function() {
        if (this.dateRange && this.dateRange.start && this.dateRange.end) {
          return {
            params: {
              brand_id: this.advertiserId,
              start_time: this.dateRange.start,
              end_time: this.dateRange.end,
              previous_start: this.dateRange.prevStart,
              previous_end: this.dateRange.prevEnd,
            }
          }
        }
      },
    },
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.dashboard-kpis

  .kpi-row
    display: flex
    justify-content: center
    max-width: 1000px
    margin: auto

    .kpi-block
      height: auto
      flex-flow: column
      justify-content: end

  .kpi-wrapper
    border-right: 1px solid #deeefe
    flex-basis: 25%
    padding: 0 .5rem
    text-align: center

    &:last-child
      border-right: none

    .lift
      color: #3adb76
      font-family: "AileronLight"

      &.negative
        color: $negative-hover

  .kpi-title
    font-size: 1.2rem
    line-height: 1.2
    margin-bottom: .75rem
    height: 3.0rem

  .data-block
    align-items: center
    display: flex
    justify-content: center

    .loading-icon
      height: 18px
      margin: 0
      width: 18px

  svg
    fill: $primary-color
    height: 18px
    margin-right: 5px
    width: 18px

  .kpi-data
    font-size: 1.25rem
    font-weight: bold

svg.paper-plane-icon
  fill: #5B6FFB

svg.pointer-icon
  fill: #12E8D6
  margin-right: 10px

svg.cart-icon
  fill: #5FF89E
  margin-right: 10px

svg.dollar-icon
  fill: lightgreen
  margin-right: 5px

svg.shopping-bag-icon
  fill: #53E7D2
  margin-right: 10px

.divider
  border-top: 1px solid #deeefe
  display: block
  margin: .75rem auto
  padding-left: 0
  width: 60%
</style>